import { Chain } from 'viem';

export const ETHEREAL_TESTNET_CHAIN: Chain = {
  id: 657468,
  name: 'Ethereal Testnet',
  nativeCurrency: { name: 'USDe', symbol: 'USDe', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.etherealtest.net/'],
      webSocket: ['wss://rpc.etherealtest.net'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Ethereal Testnet Explorer',
      url: 'https://explorer.etherealtest.net',
    },
  },
} as const;

export const ETHEREAL_DEVNET_CHAIN: Chain = {
  id: 657469,
  name: 'Ethereal Devnet',
  nativeCurrency: { name: 'USDe', symbol: 'USDe', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.etherealdev.net/'],
      webSocket: ['wss://rpc.etherealdev.net'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Ethereal Devnet Explorer',
      url: 'https://explorer.etherealdev.net',
    },
  },
} as const;
